import React from 'react';
import '../styles/Button/Button.scss';
import GetQuestionGrouping from '../utils/QuestionGrouping';
import triangle from '../assets/images/triangle.png';
import TranslationLabel from '../components/TranslationLabel';

function Pagination({questionNumber, onChange, translations}) {
  const QuestionGrouping = GetQuestionGrouping(translations);

  const getQuestionGroup = () => {
    let match;

    QuestionGrouping.forEach(questionGroup => {
      const matches = questionGroup.questions?.filter(i => i.v === questionNumber);

      if (matches.length > 0) {
        match = questionGroup.questions;
      }
    });

    return match;
  };

  const questions = getQuestionGroup();

  const previousQuestion = () => {
    if (onChange) {
      onChange(prevQues.v);
    }
  };

  const nextQuestion = () => {
    if (onChange) {
      onChange(nextQues.v);
    }
  };

  const questionIndex = () => {
    let ret;

    questions?.forEach((ques, i) => {
      if (ques.v === questionNumber) {
        ret = i;
      }
    });

    return ret;
  };

  const currentIndex = questionIndex();

  let nextQues;
  let prevQues;

  if (currentIndex > 0) {
    prevQues = questions[currentIndex - 1];
  }

  if (currentIndex < questions?.length) {
    nextQues = questions[currentIndex + 1];
  }

 

  return (
    <div className="pagination p-3 d-flex justify-content-center align-items-center">
      {prevQues && (
        <div onClick={previousQuestion} className="mr-3 pointer light-gray">
          <img className="mx-3" src={triangle} alt="previous logo" />
          <span>
            {' '}
            <TranslationLabel id="label_06" defaultValue="Previous" />
          </span>
        </div>
      )}
      {nextQues && (
        <div onClick={nextQuestion} className={`pointer light-gray`}>
          <span>
            {' '}
            <TranslationLabel id="label_01" defaultValue="Next" />
          </span>
          <img className="next-logo mx-3" src={triangle} alt="next logo" />
        </div>
      )}
    </div>
  );
}

export default Pagination;
